import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';

import {
    UnitsService, UnitFilesService,
    InvestorService, InvestorCustomActionsService,
    ScriptLoaderService,
    PropertyService, PropertyCustomService, ConfigService
} from './../../../../../_services';
import { Unit, UNIT_INCLUDES, Investor, Property, TypeUnit } from './../../../../../_models';
import { UnitFormComponent } from '../unit-form';


@Component({
    templateUrl: '../unit-form/unit-form.component.html',
    styleUrls: ['../unit-form/unit-form.component.scss']
})
export class UnitNewComponent extends UnitFormComponent {
    formHeader = {
        icon: 'fa fa-user',
        text: 'NUEVA UNIDAD'
    }
    constructor(private _fbNew: FormBuilder,
        private _scriptNew: ScriptLoaderService,
        private _locationNew: Location,
        private _routeNew: ActivatedRoute,
        private _routerNew: Router,
        private _domSanitizerNew: DomSanitizer,
        private _unitData: Unit,
        private _investor: Investor,
        private _property: Property,
        private _type: TypeUnit
    ) {
        super(_fbNew,
            _scriptNew,
            _locationNew,
            _routeNew,
            _routerNew,
            _domSanitizerNew,
            _unitData,
            _investor,
            _property,
            _type
        );
        this.form.valueChanges.subscribe(formValue => {
            if (this.form.valid) {
                this.unitData.calculateAgain(formValue, (): number => {
                    return this.unitData.item.getMottoValuePool();
                });
                this.requests$ = this.unitData.post(this.getFormData(formValue)).map(unit => {
                    this.unitId = Number(unit.id);
                    return unit;
                });
            }
        });
        this._router.events.subscribe((route) => {
            if (route instanceof NavigationEnd) {
                this._investor.make({});
                this._property.make({});
                this._type.make({});
            }
        });
        this.dataFetched = true;
    }

    end() {
        this._router.navigate([`/units/${this.unitId}`]);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/units/unit-new/unit-new.component.ts